import { Skeleton, Typography } from 'antd';

import AdaptiveCard from '@/components/shared/AdaptiveCard';
import ImageRatio from '@/components/shared/ImageRatio';
import { getCdnUrl } from '@/helpers';
import { ICourseShelf } from '@/interfaces/course';
import { useGetCourseShelfQuery } from '@/services/resume';
import { DOMAIN, MAIN_SUBDOMAIN } from '@/settings';
import styled, { StyledProp, css } from '@/styled';

import CourseDefaultCover from './DefaultCover';
import Shelf from '../../Shelf';

interface IProps extends StyledProp {}

const CourseShelf = (props: IProps) => {
  const { data, isLoading } = useGetCourseShelfQuery('');

  if (!data?.length && !isLoading) {
    return null;
  }

  if (isLoading) {
    <Shelf title={<Skeleton />} carouselProps={{ slidesToShow: 5 }} withBorder={true}>
      {Array.from(Array(5).keys()).map(key => (
        <swiper-slide key={key}>
          <AdaptiveCard size='177.83%' cover={''} />
        </swiper-slide>
      ))}
    </Shelf>;
  }

  return (
    <>
      {data?.map(course => (
        <div key={course.id} {...props}>
          <Shelf
            title={
              <>
                <Typography.Title level={3} ellipsis>
                  {course.title}
                </Typography.Title>
                <Typography.Link
                  underline
                  href={getCourseDomain(course)}
                  target={getCourseDomainTarget(course)}
                  rel='noopener noreferrer'
                >
                  Ver curso
                </Typography.Link>
              </>
            }
            carouselProps={{ slidesToShow: 5 }}
            withBorder={true}
          >
            {course.modules.map(module => {
              if (!module.banner) {
                return (
                  <swiper-slide key={module.id}>
                    <CourseDefaultCover to={getCourseDomain(course)} {...module} />
                  </swiper-slide>
                );
              }

              return (
                <swiper-slide key={module.id}>
                  <div className='hover'>
                    <CourseDefaultCover
                      className='cover'
                      to={getCourseDomain(course)}
                      target={getCourseDomainTarget(course)}
                      {...module}
                    />
                    <ImageRatio aspect='9:16' src={getCdnUrl(module.banner)} alt={module.title} />
                  </div>
                </swiper-slide>
              );
            })}
          </Shelf>
        </div>
      ))}
    </>
  );
};

export default styled(CourseShelf)(
  ({ theme }) => css`
    & .carouselNavigator-container {
      height: 100%;
    }

    .hover {
      .cover {
        transition: ${theme.motionDurationSlow};
        position: absolute;
        background-color: ${theme.palette.alpha(theme.palette.gray[12], 0.8)};
        opacity: 0;
        z-index: 3;

        ${theme.breakpoints.down('md')} {
          opacity: 1;
        }

        svg {
          color: white;
        }
      }

      &:hover {
        .cover {
          opacity: 1;
        }
      }
    }
  `
);

function getCourseDomain(course: ICourseShelf) {
  return `https://${course?.portal?.subdomain || MAIN_SUBDOMAIN}${DOMAIN}/curso/${course.hash}`;
}

function getCourseDomainTarget(course: ICourseShelf) {
  return course?.portal?.subdomain ? '_blank' : '_self';
}
